import $                   from 'jquery';
import FormStep            from '../../classes/form-step';
import extend              from '../../util/extend';
import { formatTrial }     from '../../util/trialPeriod';
import template            from './template.hbs';

const CB   = 'connect-bulk';
const CNB  = 'connect-non-bulk';
const CNBH = 'connect-non-bulk-hacla';
const CNBA = 'connect-non-bulk-aps';
const ebb  = [ 'tag:connect-non-bulk', 'tag:connect-non-bulk-hacla' ];

export default new FormStep({

  $el: $('<form class="form-step step-select-plan" action="canvas" />'),

  template,

  events: {
    'submit-clicked': 'track'
  },

  bindEvents() {
    this.$el.on( 'click', '.plan-select', this.onSelect.bind( this ) );
    return FormStep.prototype.bindEvents.call( this );
  },

  onSelect( e ) {
    const plan_id = e.target.dataset.plan_id;
    const plan    = window.plans.filter( p => p.id === plan_id )[ 0 ];
    const meta    = plan.metadata || {};
    const hasTag  = tag => !!meta[ `tag:${ tag }` ];
    const connect = [ CB, CNB, CNBH, CNBA ];

    this.dispatch({
      type: 'change',
      data: {
        plan: plan_id,
        plan_name: plan.name,
        plan_amount: plan.amount,
        trial_period_days: plan.starry_trial_days,
        trial_code: undefined,
        starry_connect: connect.some( hasTag )
      }
    });
  },

  formatPlanTrial( days ) {
    return days === 30 ? 'month' : days ? formatTrial( days ).str : null;
  },

  isValid( state = {} ) {
    return typeof state.plan === 'string';
  },

  getPlanRenderContext( state, plan ) {
    const meta    = plan.metadata || {};
    const down    = parseInt( meta.download_mbps, 10 ) || 200;
    const up      = parseInt( meta.upload_mbps, 10 ) || 100;
    const unit_d  = down >= 1000 ? 'Gbps' : 'Mbps';
    const unit_u  = up >= 1000 ? 'Gbps' : 'Mbps';
    const speed_d = unit_d === 'Gbps' ? down / 1000 : down;
    const speed_u = unit_u === 'Gbps' ? up / 1000 : up;
    const hasTag  = tag => !!meta[ `tag:${ tag }` ];

    return {
      id: plan.id,
      name: plan.name,
      dollars: Math.round( plan.amount / 100 ),
      download: `${ Math.floor( speed_d * 10 ) / 10 } ${ unit_d }`,
      upload: `${ Math.floor( speed_u * 10 ) / 10 } ${ unit_u }`,
      fast: down >= 200,
      ludicrous: down >= 400,
      gigabit: down >= 1000,
      premium_router: /^(totem|arrowhead)$/.test( meta.unit_type ),
      launch30: hasTag('launch30'),
      connect: hasTag( CB ) || hasTag( CNB ) || hasTag( CNBH )
    };
  },

  getRenderPlans() {
    window.plans.sort( ( a, b ) => a.amount - b.amount );
    return window.plans.slice( 0, 4 );
  },

  render( state ) {
    const copy     = extend( {}, state );
    const has_tag  = ( p, t ) => p.metadata && p.metadata.hasOwnProperty( t );
    const plans    = this.getRenderPlans();

    const contexts = plans.map( plan => {
      return this.getPlanRenderContext( copy, plan );
    });

    const launch30 = plans.some( plan => !!plan.launch30 );
    const multi    = plans.length > 1;

    const extended = extend( {}, copy, {
      multi,
      launch30,
      plans: contexts,
      ebb_qualified: ebb.some( t => plans.some( p => has_tag( p, t ) ) )
    });

    return FormStep.prototype.render.call( this, extended );
  },

  // called by trackStep() in the signup FormSequence
  trackingData() {
    const plans = this.getRenderPlans();

    return {
      plans_rendered: Math.min( plans.length, 3 ),
      plans: plans.map( plan => plan.id )
    };
  },

  track( state ) {
    if ( window.acumen ) {
      window.acumen.track( 'web-submit-select_plan', {
        plan_name: state.plan
      });
    }
  }
});
